import { useRef, useState, useCallback } from "react";
export var useControlled = function useControlled(_a) {
  var controlled = _a.controlled,
      defaultProp = _a.default;
  var isControlled = useRef(controlled !== undefined).current;

  var _b = useState(defaultProp),
      valueState = _b[0],
      setValue = _b[1];

  var value = isControlled ? controlled : valueState;
  var setValueIfUncontrolled = useCallback(function (v) {
    if (!isControlled) {
      setValue(v);
    }
  }, []);
  return [value, setValueIfUncontrolled];
};